import React from 'react';

import { TopBar } from '../../../shared/components/topbar';
import { MerchantDetailCard } from './components/elements';
import { WebOutletsTable } from './components/web-outlets-table';
import config from '../../../shared/services/config';
import AuthManager from '../../../shared/services/AuthManager';
import { useBreakpoint } from '../../../shared/hooks/useBreakpoint';
import { MobileOutletsTable } from './components/mobile-outlets-table';
import { isFunction } from 'lodash';
import Redirection from '../../../shared/services/redirection';
import * as AuthEvents from '../../../shared/constants/cleverTapEvents';
import cleverTap from '../../../shared/services/cleverTap';

export const Outlets = ({ history, match }) => {
  const mid = match?.params?.mid;
  const userData = AuthManager.getUser();
  const isMobile = useBreakpoint('m');

  const UI = config.get('uiv2', {})

  const onOutletSelect = (outletDetails = {}) => {
    const { outletName, outletId, address, haveChild } = outletDetails;
    AuthManager.persistOutletDetailsToCookies(outletId ? { outletName, outletId, address, haveChild } : {})
    const loginRedirectUrl = config.get('loginRedirectUrl');
    if (isFunction(loginRedirectUrl)) {
      loginRedirectUrl(AuthManager.getUser(), true, Redirection.getURL());
    } else {
      this.props.history.push({
        pathname: loginRedirectUrl,
      });
    }
  }

  const logout = async () => {
    let userData = JSON.parse(localStorage.user);
    await cleverTap.event(AuthEvents.MID_SCREEN_CLICKED, {
      'Button clicked': 'Use a different account',
      'Email id': userData.email,
      UUID: userData.uuid,
    });
    await cleverTap.event(AuthEvents.LOGOUT, {
      Email: userData.email,
    });
    localStorage.clear();
    window.location.href = '/app/account';
  };
  return <div className='tw-preflight textured-bg'>
    <TopBar actionBtns={[{
      label: 'Sign Out',
      onClick: logout,
      variant: 'SECONDARY',
      startIcon: { type: 'sign-out-alt' }
    }]} />
    {
      isMobile ? <MobileOutletsTable mid={mid} onOutletSelect={onOutletSelect} history={history} /> : (
        <div className='container cards-container tw-my-16'>
          <div className='tw-flex tw-flex-col tw-gap-16'>
            <div className='tw-flex tw-items-center tw-gap-4 tw-cursor-pointer tw-text-green-500 tw-w-200' onClick={() => {
              history.push({
                pathname: '/account/team-accounts',
              });
            }}>
              <UI.PayuIcon type='product-card_right-arrow-with-trail' size='14px' className='tw-rotate-180' />
              <UI.Typography variant='P2' weight='semi-bold'>Back to all MIDs</UI.Typography>
            </div>
            <UI.Grid cols={3} gap={16}>
              <div>
                {mid ? <MerchantDetailCard
                  mid={userData?.mid}
                  businessName={userData?.name}
                  aclRoleName={userData?.acl_role_name}
                  onMasterDashSelect={onOutletSelect}
                  logo={userData?.logo}
                /> : null}
              </div>
              <UI.GridItem colSpan={2}>
                <WebOutletsTable mid={mid} history={history} onOutletSelect={onOutletSelect} />
              </UI.GridItem>
            </UI.Grid>
          </div>
        </div>
      )
    }
  </div>
}
